import Box from '../Box';

type TabPanelProps = {
  children?: React.ReactNode;
  name?: string;
  index: number;
  value: number;
  padding?: number | string;
};

function TabPanel(props: Readonly<TabPanelProps>) {
  const { children, value, index, name, padding, ...other } = props;

  return (
    <section
      role="tabpanel"
      hidden={value !== index}
      id={`${name}-tabpanel-${index}`}
      aria-labelledby={`${name}-tab-${index}`}
      {...other}
      style={{ flexGrow: 1 }}
    >
      {value === index && (
        <Box height="100%" p={padding ?? 3}>
          {children}
        </Box>
      )}
    </section>
  );
}

export default TabPanel;
